import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CError',
  props: {
    message: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})